const counter = document.querySelector(".tree-count");
const speed = 10;
let value = 0;
//DO NOT CHANGE animated VARIABLE
let animated = false;

const getValue = async () => {
  const url = "https://sheets.googleapis.com/v4/spreadsheets/1F2p4c53QCx0aWU6y-W2tFOSPVoFn1lUoqaNL9j8H_K0/values/total!A1:A1?key=AIzaSyAdryYW8y9UV3nMFfPD28sBuAc750YNfMY";
  const response = await fetch(url);
  const json = await response.json();
  if (!json.values[0][0]) {
    value = 44000;
  } else {
    value = json.values[0][0];
  }
  checkIsVisible();
}

const animate = (start = 0, duration = 1000) => {
  animated = true;
  let startTimestamp = null;
  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    counter.innerText = Math.floor(progress * (value - start) + start).toLocaleString('en-US');
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  }
  window.requestAnimationFrame(step);
};

const checkIsVisible = async () => {
  const element = document.getElementById('tree-counter');
  const rect = element.getBoundingClientRect();
  if (rect.bottom <= window.innerHeight && !animated) {
    await animate(0, 1000);
  }
}

window.addEventListener('scroll', checkIsVisible);

(async () => {
  await getValue();
})();